import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DeleteAppoinementComponent } from "./delete-appoinement/delete-appoinement.component";
import { CustomerBookAppointmentComponent } from "./customer-book-appointment/customer-book-appointment.component";
import { BookingComponent } from "./booking/booking.component";
import { BookingInquiryComponent } from "./booking-inquiry/booking-inquiry.component";
import { BookingConfirmationComponent } from "./booking-confirmation/booking-confirmation.component";
import { InquiryComponent } from "./inquiry/inquiry.component";

export const App1Routes: Routes = [
  { path: "view-appointment/:id", component: DeleteAppoinementComponent },
  {
    path: "book/:slug",
    component: CustomerBookAppointmentComponent,
  },
  {
    path: "book",
    component: BookingComponent,
  },
  {
    path: "customer/booking-inquiry",
    component: BookingInquiryComponent,
  },
  {
    path: "customer/booking-confirmation",
    component: BookingConfirmationComponent,
  },
  {
    path: "customer/inquiry",
    component: InquiryComponent,
  },
];
